import { useCallback, useMemo, useState } from 'react';
import { OptionKey, usePaginationParams } from '@common-fe/common-fe';
import dayjs from 'dayjs';

import { ALL_OPTION, SORT_OPTIONS } from '@/common/constants';
const startYear = 2022;
const currentYear = dayjs().year();

const useSearchParams = () => {
  const [sortParams, setSortParams] = useState<OptionKey>(SORT_OPTIONS[1].key);

  const [years, setYears] = useState<OptionKey[]>([currentYear.toString(), (currentYear - 1).toString()]);

  const yearOptions = useMemo(() => {
    const currentYear = dayjs().year();

    const taxYears = Array.from({ length: currentYear - startYear }, (_, index) => currentYear - index);

    const taxYearsOptions = taxYears.map((statementYear) => ({
      key: `${statementYear}`,
      value: `${statementYear}`,
      title: `${statementYear}`,
    }));

    return [ALL_OPTION, ...taxYearsOptions];
  }, []);
  const { page, setPage, setPerPage, perPage, searchString, setSearchString, currentSearch } =
    usePaginationParams(10);
  const handleSetYears = useCallback(
    (values: OptionKey[]) => {
      setYears(values);
      setPage(1);
    },
    [setPage]
  );
  return {
    yearOptions,
    page,
    setPage,
    setPerPage,
    perPage,
    searchString,
    setSearchString,
    currentSearch,
    sortParams,
    setSortParams,
    years,
    setYears: handleSetYears,
  };
};

export default useSearchParams;
